<template>
  <div id="app" class="intro-main">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {

  }
}
</script>

<style>
.intro-main{
  //background: linear-gradient(to right,#fff,#ddd,#fff);
}
#container .container{
  min-height: 1050px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue